const ERROR_MAP = {
  FLEET_MANAGEMENT_VEHICLE_NOT_FOUND: "contract_not_found",
  FLEET_MANAGEMENT_CUSTOMER_NOT_FOUND: "contract_not_found",
  FLEET_MANAGEMENT_CONTRACT_NUMBER_PLATE_DOES_NOT_MATCH: "does_not_match",
  FLEET_MANAGEMENT_CONTRACT_TYPE_DOES_NOT_MATCH: "wrong_contract_type",
};

type BackendErrorCode = keyof typeof ERROR_MAP;
export type FleetErrorCode = (typeof ERROR_MAP)[BackendErrorCode] | "general_error";

export function mapErrorCode(unknownCode: unknown): FleetErrorCode {
  if (typeof unknownCode === "string" && unknownCode in ERROR_MAP) {
    return ERROR_MAP[unknownCode as BackendErrorCode];
  }
  return "general_error";
}
